import { useTranslation } from 'react-i18next'

import { trackingPageBlockIds } from '@reveni-io/reveni-ui'

import { getBlockName } from '@/configuration/pages/ConfigurationPage/OrderTrackingPageConfiguration/TrackingPageEditorModal/helpers'

import HiddenBlockPlaceholder from './HiddenBlockPlaceholder/HiddenBlockPlaceholder'

const GridBlockContent = ({ block, hiddenReasons, blockSettings, isMobileView }) => {
  const { t } = useTranslation()

  if (hiddenReasons) {
    return (
      <HiddenBlockPlaceholder
        blockName={getBlockName(block.id, blockSettings, t)}
        hiddenReasons={hiddenReasons}
        isBar={block.definition.id === trackingPageBlockIds.announcementBar}
        isMobileView={isMobileView}
      />
    )
  }

  return block.content
}

export default GridBlockContent
